import { Component } from '@angular/core';

@Component({
  selector: 'app-tool-help',
  templateUrl: './tool-help.component.html',
  styleUrl: './tool-help.component.scss',
  standalone: true,
})
export class ToolHelpComponent {

}
